<script lang="ts">
  import BasicSearch from "./BasicSearch/BasicSearch.svelte";
  import { search } from "app/stores/search";
  import Modal from "$components/+shared/Modal/Modal.svelte";
  import AskAI from "./AskAI/AskAI.svelte";
  import { onMount } from "svelte";
  import { onNavigate } from "$app/navigation";
  import { getMediaQuery } from "app/utils/mediaQuery";
  import cx from "classnames";

  enum Step {
    BASIC = "basic",
    ASKAI = "askai",
  }

  const isTabletAndDesktop = getMediaQuery("tablet");

  let step: Step = Step.BASIC;
  let value: string;
  let timeout: NodeJS.Timeout;

  onMount(() => {
    // cleanup timeout
    return () => clearTimeout(timeout);
  });

  onNavigate((event) => {
    // prevent modal closing on initial redirect from root docs to a doc
    if (event.from?.route.id?.endsWith("/doc")) return;
    // close modal on navigation and reset state
    $search = false;
    step = Step.BASIC;
    value = "";
  });
</script>

<Modal
  open={$search}
  position={step === Step.ASKAI && !$isTabletAndDesktop ? "center" : "top"}
  withCloseIcon={step === Step.ASKAI}
  maxWidth="max-w-[750px] 3xl:max-w-[900px]"
  maxHeight={cx({
    "": step === Step.BASIC,
    "max-h-[600px] sm:max-h-[810px] 3xl:max-h-[1200px]": step === Step.ASKAI,
  })}
  on:close={() => {
    $search = false;
    value = "";
    step = Step.BASIC;
  }}
>
  {#if step === Step.BASIC}
    <BasicSearch on:ask-ai={() => (step = Step.ASKAI)} bind:value on:close />
  {/if}

  {#if step === Step.ASKAI}
    <AskAI
      currentPrompt={value}
      on:start={() => {
        step = Step.BASIC;
        value = "";
      }}
    />
  {/if}
</Modal>
